// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".data-table-header{background-color:#4d8ab7}", "",{"version":3,"sources":["webpack://./resources/js/components/DataTable.vue"],"names":[],"mappings":"AAGI,mBACI,wBAFR","sourcesContent":["\n    @import '../../sass/variables';\n\n    .data-table-header {\n        background-color: $primary;\n    }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
